import * as React from 'react';
import {
    Create,
    TextInput,
    required,
    SimpleForm,
    DateInput,
    SelectInput,
    ReferenceInput,
    minValue,
    NumberInput,
} from 'react-admin';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { STATUS, STATUSES } from '../../common/constants';
import SlugInput from '../../common/inputs/SlugInput';

const TopicCreate = () => {
    let { programId, subjectId, chapterId } = useParams();
    if (!subjectId) {
        return <LoadingSection />;
    }
    return (
        <Create
            redirect={() => {
                return `programs/${programId}/subjects/${subjectId}/chapters/${chapterId}/topics`;
            }}
            resource={'topics'}
        >
            <SimpleForm
                defaultValues={{
                    programId: programId,
                    subjectId: subjectId,
                    chapterId: chapterId,
                }}
            >
                <TextInput source="name" fullWidth validate={[required()]} />
                <SlugInput source="slug" fullWidth />
                <SelectInput
                    source="status"
                    label={'Status'}
                    fullWidth
                    validate={[required()]}
                    choices={STATUS}
                />
                <NumberInput
                    source="displayOrder"
                    type={'number'}
                    fullWidth
                    validate={[minValue(0)]}
                />
            </SimpleForm>
        </Create>
    );
};

export default TopicCreate;
